import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from 'components/organisms';
import { Menu } from 'components/organisms/Menu';
import s from '../../styles/common/footer.module.scss';

type Props = {
  children: React.ReactNode;
};

export const SurveySimpleLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Helmet
        title={'P-man 三菱地所が事業化検討中 ペットのコンシェルジュがいる賃貸マンション'}
        meta={[
          {
            name: 'description',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
          { property: 'og:title', content: 'P-man 三菱地所が事業化検討中 ペットのコンシェルジュがいる賃貸マンション' },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: 'https://p-man.mec.co.jp/' },
          { property: 'og:image', content: 'https://p-man.mec.co.jp/ogp.png' },
          {
            property: 'og:description',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:image', content: 'https://p-man.mec.co.jp/ogp.png' },
          {
            name: 'twitter:site',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
        ]}
      >
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-BTQ7CE5MB4"></script>
        <script>
          {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-BTQ7CE5MB4', { send_page_view: false });
            `}
        </script>
      </Helmet>

      <Header />
      <Menu />
      {children}
      <SurveySimpleFooter />
    </>
  );
};

// Survey用のシンプルなフッター（navとcopyrightのみ）
const SurveySimpleFooter: React.FC = () => {
  return (
    <footer className={s.footer}>
      <div className={s.contents}>
        <nav>
          <ul>
            <li>
              <a href="https://www.mec.co.jp/privacy/" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <Link to={'/terms'}>利用規約</Link>
            </li>
          </ul>
        </nav>
        <p className={s.copyright}>COPYRIGHT © MITSUBISHI ESTATE CO., LTD. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  );
};

export default SurveySimpleLayout;